import { combineReducers } from "redux";
import monitor from "./monitor/monitorReducer";

export default combineReducers({
    monitor
});


/** WEBPACK FOOTER **
 ** ./src/main/javascript/compliance/complianceReducer.js
 **/